import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29eb9bf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subpage" }

import TabMenu from '@/common/components/snedson-material-components/tab-menu/tab-menu.vue';
import { ITabMenuProps } from '@/common/components/snedson-material-components/tab-menu/tab-menu.types';
import { reactive } from 'vue';
import { ScheduleSubpage } from './SchedulePage.types';
import router from '@/router';
import ModifiedScheduleSubpage from './Subpages/ModifiedScheduleSubpage/ModifiedScheduleSubpage.vue';
import UsualScheduleSubpage from './Subpages/UsualScheduleSubpage/UsualScheduleSubpage.vue';
import { HandleAnimation } from '@/services/animation-service';
import { animationState } from '@/services/animation-service/animation-state.ts';


export default /*#__PURE__*/_defineComponent({
  __name: 'SchedulePage',
  setup(__props) {

const state = reactive<ITabMenuProps>({
    tabs: [
        {
            id: ScheduleSubpage.Modified,
            title: 'Измененное',
        },
        {
            id: ScheduleSubpage.Usual,
            title: 'Стандартное',
        },
    ],
    selectedTabItemId: ScheduleSubpage.Modified,
});

const selectTab = (tabId: ScheduleSubpage) => {
    animationState.flow = HandleAnimation('horizontal', state.selectedTabItemId, tabId);
    state.selectedTabItemId = tabId;

    if (tabId == ScheduleSubpage.Modified) {
        router.push({ name: 'sn.teacher.schedule.mse' });
    } else {
        router.push({ name: 'sn.teacher.schedule.use' });
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TabMenu, {
      props: state,
      onChange: selectTab
    }, null, 8, ["props"]),
    _createElementVNode("div", _hoisted_1, [
      (state.selectedTabItemId === _unref(ScheduleSubpage).Modified)
        ? (_openBlock(), _createBlock(ModifiedScheduleSubpage, { key: 0 }))
        : (state.selectedTabItemId === _unref(ScheduleSubpage).Usual)
          ? (_openBlock(), _createBlock(UsualScheduleSubpage, { key: 1 }))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})